import { render, staticRenderFns } from "./FeedModeration.vue?vue&type=template&id=5e257bce&"
import script from "./FeedModeration.vue?vue&type=script&lang=js&"
export * from "./FeedModeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports